import {twMerge} from '../../../../common/twMerge';
import {Icon} from '../../../../design-system/atoms/Icon/Icon';
import {IconType} from '../../../../design-system/atoms/Icon/IconType.enum';
import {LabelBadge} from '../../../../design-system/molecules/LabelBadge/LabelBadge';
import {LabelBadge18Type} from '../../../../design-system/molecules/LabelBadge/LabelBadge18Type.enum';
import {LabelBadgeSizeType} from '../../../../design-system/molecules/LabelBadge/LabelBadgeSizeType.enum';
import {
  ContentHomeBadgeType,
  ContentHomeLabelBadge as ContentHomeLableBadgeType,
} from '../../../../graphql/generated/types';
import {CONTENT_HOME_WAITFREE_BADGE_TYPE_MAP} from '../constant';

export function ContentHomeLabelBadge({
  labelBadge,
  className,
}: {
  labelBadge: ContentHomeLableBadgeType;
  className?: string;
}) {
  switch (labelBadge.badgeType) {
    case ContentHomeBadgeType.BadgeWaitfree:
    case ContentHomeBadgeType.Badge0HourWaitfree:
    case ContentHomeBadgeType.Badge1HourWaitfree:
    case ContentHomeBadgeType.Badge2HourWaitfree:
    case ContentHomeBadgeType.Badge3HourWaitfree:
      return (
        <Icon
          type={
            CONTENT_HOME_WAITFREE_BADGE_TYPE_MAP[labelBadge.badgeType] ||
            IconType.ContentHomeTimeStatic
          }
          className={twMerge('h-18pxr', className)}
          disableActiveEffect
        />
      );
    case ContentHomeBadgeType.Badge15Static:
      return (
        <LabelBadge
          sizeType={LabelBadgeSizeType.Size18}
          type={LabelBadge18Type.badge}
          badge={IconType.ContentHome15Static}
          className={className}
        />
      );
    case ContentHomeBadgeType.Badge19Static:
      return (
        <LabelBadge
          sizeType={LabelBadgeSizeType.Size18}
          type={LabelBadge18Type.badge}
          badge={IconType.ContentHome19Static}
          className={className}
        />
      );
    case ContentHomeBadgeType.Badge19SelfStatic:
      return (
        <LabelBadge
          sizeType={LabelBadgeSizeType.Size18}
          type={LabelBadge18Type.badge}
          badge={IconType.ContentHome19SelfStatic}
          className={className}
        />
      );
    case ContentHomeBadgeType.LabelBadgeSaleIng:
    case ContentHomeBadgeType.LabelBadgeSaleRest:
    case ContentHomeBadgeType.LabelBadgeSaleStop:
      return (
        <LabelBadge
          sizeType={LabelBadgeSizeType.Size18}
          type={SALE_BADGE_TYPE_MAP[labelBadge.badgeType]}
          label={labelBadge.label ?? ''}
          className={className}
        />
      );
    case ContentHomeBadgeType.LabelBadgeDayOfWeek:
    case ContentHomeBadgeType.LabelBadgeWaitInfo:
      return (
        <LabelBadge
          sizeType={LabelBadgeSizeType.Size18}
          type={LabelBadge18Type.el70}
          label={labelBadge.label ?? ''}
          className={className}
        />
      );
  }
  return null;
}

const SALE_BADGE_TYPE_MAP: {
  [key in Extract<
    ContentHomeBadgeType,
    | ContentHomeBadgeType.LabelBadgeSaleIng
    | ContentHomeBadgeType.LabelBadgeSaleRest
    | ContentHomeBadgeType.LabelBadgeSaleStop
  >]: LabelBadge18Type;
} = {
  [ContentHomeBadgeType.LabelBadgeSaleIng]: LabelBadge18Type.red,
  [ContentHomeBadgeType.LabelBadgeSaleRest]: LabelBadge18Type.gray,
  [ContentHomeBadgeType.LabelBadgeSaleStop]: LabelBadge18Type.blue,
};
